<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'refresh'): void;
  (e: 'close'): void;
}>();

const onClose = () => {
  emit('close');
};
</script>

<template>
  <ot-banner
    class="price-chart-banner"
    variant="warning"
  >
    <template #default>
      <div class="price-chart-banner__content">
        <span>{{ $t('modules.charting.restoreSavedCharts.banner.text') }}</span>
        <x-button
          size="3xs"
          variant="text-like"
        >
          <ot-icon
            class="price-chart-banner__banner-icon"
            name="refresh"
            @click="emit('refresh')"
          />
        </x-button>
      </div>
      <x-button
        class="price-chart-banner__banner-button price-chart-banner__banner-button--close"
        size="3xs"
        variant="text-like"
      >
        <ot-icon
          class="price-chart-banner__banner-icon"
          name="close"
          @click="onClose"
        />
      </x-button>
    </template>
  </ot-banner>
</template>

<style lang="scss" scoped>
.price-chart-banner {
  position: relative;
  padding-left: 20px;

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__banner-icon {
    width: 16px;
  }

  &__banner-button {
    &--close {
      position: absolute;
      top: 4px;
      left: 4px;
    }
  }
}
</style>
